module.exports = __webpack_public_path__ + "static/media/iFinDEX Logo@3x.220649e8.png";